import './DateMenu.module.less'
import dayjs from 'dayjs'
import { Button, Calendar, Menu } from 'antd'
import {
  CaretLeftOutlined,
  CaretUpOutlined,
  CaretRightOutlined,
  CaretDownOutlined,
} from '@ant-design/icons'

const locale = {
  lang: { locale: 'en', shortWeekDays: dayjs.weekdaysShort() },
}

export default function DateMenu({
  date = dayjs().format('YYYY-MM-DD'),
  view = '',
  onViewChange = () => null,
  onSelect = () => null,
  dateCellRender = () => null,
}) {
  const dates = Array.from({ length: 4 }, (d, i) => dayjs(date).add(i, 'day'))
  if (view !== 'calendar') {
    return (
      <Menu
        style={{ paddingLeft: '12px', paddingTop: '6px' }}
        className="date-menu ant-space ant-space-horizontal ant-space-align-center"
        mode="horizontal"
        selectedKeys={[date]}
        onSelect={({ key }) => {
          if (key === '0') {
            const page = document.getElementById('content-main')
            if (!page.scrollTo) page.scrollTop = 0
            else page.scrollTo({ top: 0, behavior: 'smooth' })

            onViewChange('calendar')
          } else {
            onSelect(key)
          }
        }}
      >
        {dates.map((d) => (
          <Menu.Item className="ant-space-item" key={d.format('YYYY-MM-DD')}>
            {d.format('DD ddd')}
            {dateCellRender(d)}
          </Menu.Item>
        ))}
        <Menu.Divider style={{ width: '2px', height: '30px' }} />
        <Menu.Item className="ant-space-item" key="0">
          <span style={{ fontWeight: 600, color: '#969696' }}>
            {dates[0].format('MMM')}
          </span>
          <CaretDownOutlined style={{ marginLeft: '16px', color: 'black' }} />
        </Menu.Item>
      </Menu>
    )
  }

  return (
    <div className="date-menu-calendar">
      <Calendar
        dateCellRender={dateCellRender}
        fullscreen={false}
        mode="month"
        value={dayjs(date)}
        locale={locale}
        onSelect={(d) => {
          onSelect(d.format('YYYY-MM-DD'))
          onViewChange('')
        }}
        headerRender={(cal) => {
          const current = cal.value.clone()

          return (
            <div style={{ textAlign: 'center' }}>
              <Button
                type="text"
                onClick={() => {
                  onSelect(current.add(-1, 'month').format('YYYY-MM-DD'))
                }}
                icon={<CaretLeftOutlined />}
              />
              <span
                style={{
                  padding: '8px 12px',
                  display: 'inline-block',
                }}
              >
                {current.format('MMMM ')}
                <span>{current.year()}</span>
              </span>
              <Button
                type="text"
                onClick={() => {
                  onSelect(current.add(1, 'month').format('YYYY-MM-DD'))
                }}
                icon={<CaretRightOutlined />}
              />
            </div>
          )
        }}
      />
      <div
        style={{
          textAlign: 'right',
          background: '#f8f8f8',
          padding: '4px 10px 8px',
          borderBottom: '1px solid #e8e8e8',
        }}
      >
        <Button
          type="text"
          onClick={() => onViewChange('')}
          icon={<CaretUpOutlined />}
        />
      </div>
    </div>
  )
}
